
app.directive("chartDonut", function ($sce, $compile, $timeout) {
    return {
        restrict: 'EA',
        replace: true,
        scope: {
            title: '=ChartDonut',
            ngModel: '=',
            centerImage: '='
        },
        template: '<div>' +
        '<div id="chart"></div>' +
        '<div id="icons">' +
        '<img id="chart-logo" ng-src="{{centerImage}}" ' +
        'width="80" height="80" alt="">' +
        '<div ng-repeat="logoItem in ngModel" ' +
        'id="{{\'chart-logos-\' + $index}}" class="chart-logos" ' +
        'ng-class="[logoItem.className, \'chart-logos-\' + $index]" ' +
        'ng-style="logoItem.styles"> ' +
        '<span class="chart-logos__label">{{logoItem.text}}</span> ' +
        '</div>' +
        '</div>' +
        '</div>',

      
        link: function (scope, element) {
            scope.ngModel = convertdata(scope.ngModel);

            scope.$watch("ngModel",function(newValue,oldValue) {
                scope.ngModel = convertdata(newValue);
                setTimeout(function () {
                    scope.clickOnGraph(
                      { index: 0 },
                      $('.c3-chart-arcs path')[0]
                    )
                }, 100);
            });

            var activeIndex = 0;
            scope.chartColumns = [];
            for (var i = 0, l = scope.ngModel.length; i < l; i++) {
                scope.chartColumns.push(
                  [
                    scope.ngModel[i].label,
                    scope.ngModel[i].quantity
                  ]
                );
            }
            var chart = c3.generate({
                bindto: '#chart',
                data: {
                    columns: scope.chartColumns,
                    type: 'donut',
                    order: null,
                    selection: {
                        enabled: true
                    },
                    onclick: function (d, i) {
                        scope.clickOnGraph(d, i);
                    },
                    onmouseover: function (d, i) {
                        document.getElementById('chart-logos-' + d.index).classList.add('active');
                        element.parents('.chart-wrapper').addClass('hover focused-' + d.index);
                    },
                    onmouseout: function (d, i) {
                        document.getElementById('chart-logos-' + d.index).classList.remove('active');
                        element.parents('.chart-wrapper').removeClass('hover');
                        element.parents('.chart-wrapper').removeClass('focused-' + d.index);
                    }
                },
                donut: {
                    title: element.attr('title'),
                    label: {
                        format: function (value, ratio, id) {
                            return '';
                        }
                    },
                    width: 70
                },
                legend: {
                    show: false
                },
                size: {
                    width: 320,
                    height: 350
                },
                tooltip: {
                    show: false
                }


            });

            scope.clickOnGraph = function (d, i) {
                scope.$emit('want-to-change', d);

                //element.find('.c3-chart-arc').removeClass('active');
                //$(i).parents('.c3-chart-arc').addClass('active');
                //element.parents('.chart-wrapper').removeClass('focused-a' + activeIndex).addClass('active focused-a' + d.index);
                //activeIndex = d.index;
                //$('.chart-logos.selected').removeClass('selected');
                //document.getElementById('chart-logos-' + d.index).classList.add('selected');
            };

            scope.$on('need-to-chage', function (event, data) {
                var index = data.index;

                element.find('.c3-chart-arc').removeClass('active');
                element.find('.c3-chart-arc').eq(index).addClass('active');



                // element.parents('.chart-wrapper').removeClass('active').addClass('active focused-a' + index);
                //activeIndex = d.index;

                // to put in white the icone.
                $('.chart-logos.selected').removeClass('selected');
                if (document.getElementById('chart-logos-' + index) !== null)
                    document.getElementById('chart-logos-' + index).classList.add('selected');
            });


            // $timeout(function () {
            //     var divIcon = $('.c3-target text');
            //     for(var i=0; i < divIcon.length; i++) {
            //         var icon = scope.$parent.chartColumns[i];
            //         // divIcon[i].append('icon-menu-' + icon + '');
            //         divIcon[i].append('<i id="night-logo" class="icon-menu-'+ icon +'" ></i>');
            //     }
            // }, 3000);

            setTimeout(function () {
                /* chart.unload({
                 ids: 'data1'
                 });
                 chart.unload({
                 ids: 'data2'
                 }); */
                scope.clickOnGraph(
                  { index: 0 },
                  $('.c3-chart-arcs path')[0]
                )

            }, 100);


        }
    }
});


//function convertdata(oldData) {
    
//    if (oldData.length > 0 && oldData[0].name) {
//        var datas = [];
//        for (var i = 0; i < oldData.length; i++) {
//            var newvalue = {};
//            newvalue.styles = {};
//            newvalue.label = oldData[i].custom[0];
//            newvalue.text = oldData[i].name;
//            newvalue.number = oldData[i].value;
//            newvalue.item = 0;
//            newvalue.quantity = oldData[i].custom[3];
//            newvalue.className = oldData[i].image;
//            newvalue.styles.top = oldData[i].custom[1];
//            newvalue.styles.left = oldData[i].custom[2];
//            newvalue.custom = oldData[i].custom;
//            datas.push(newvalue);
//        }
//        return datas;
//    }
//    else
//        return oldData;
    
//}